import React from "react";
import { v4 as uuidv4 } from "uuid";
import { SubSection } from "./SubSection";
export const Fieldset = ({ children, legend, id, captionType = "legend", }) => {
    let className = captionType === "label" ? "form-group" : "";
    const uniqueId = id || uuidv4();
    return (React.createElement("fieldset", { id: uniqueId, className: className },
        captionType === "label" ? (React.createElement("span", { className: "form-control-static-label" },
            " ",
            legend,
            " ")) : (React.createElement(SubSection, { title: legend, id: `${uniqueId}-subSection` })),
        children));
};
